import { useEffect, useState } from "react";

import styles from "./addmyaddress.module.css";

import {
  useForm,
} from "react-hook-form";

import {
  Button,
  Input,
  HeadingTitle,
} from "../../../../../components/shared";

import {
  useAddUserAddressMutation,
  useStateListQuery,
  useUpdateUserAddressMutation,
} from "../../../../../queries/useUserAddress";

import {
  useUserProfile,
} from "../../../../../queries/useUserProfile";

import toast from "react-hot-toast";

import {
  FaHome,
  FaBriefcase,
  FaMapMarkerAlt,
} from "react-icons/fa";


const AddMyAddress = ({
  onClose,

  mode = "add",

  initialData = null,

  addressId = null,

  locationData = null,

  onEditLocation,
   onSave,
}) => {

  const countryId = 101;


  /* =====================================================
     ADDRESS TYPE
  ===================================================== */

  const [
    addressType,
    setAddressType,
  ] = useState(
    initialData?.address_type ||
    "Home"
  );


  /* =====================================================
     PROFILE
  ===================================================== */

  const {
    data: profileRes,

    isLoading:
      isProfileLoading,
  } = useUserProfile();


 const profileData =
  profileRes?.user;


  /* =====================================================
     FORM
  ===================================================== */

  const {
    register,

    handleSubmit,

    setValue,

    reset,

    formState: {
      errors,
    },
  } = useForm({

    defaultValues: {

      country_id:
        countryId,

      country_name:
        "India",

      state_id:
        "",

      state_name:
        "Telangana",

      name:
        "",

      address:
        "",

      city:
        "",

      zip:
        "",

      phone:
        "",

      email:
        "",

      latitude:
        "",

      longitude:
        "",
    },
  });


  /* =====================================================
     STATES
  ===================================================== */

  const {
    data: states = [],
  } =
    useStateListQuery(
      countryId
    );


  /* =====================================================
     MUTATIONS
  ===================================================== */

  const {
    mutate: addAddress,

    isPending: isAdding,
  } =
    useAddUserAddressMutation();


  const {
    mutate: updateAddress,

    isPending: isUpdating,
  } =
    useUpdateUserAddressMutation();


  const isPending =
    isAdding ||
    isUpdating;


  /* =====================================================
     SET TELANGANA
  ===================================================== */

 useEffect(() => {
  if (!states?.length) {
    return;
  }

  const telangana = states.find(
    (state) =>
      state.name?.toLowerCase() === "telangana"
  );

  if (!telangana) {
    return;
  }

  // For ADD, use Telangana automatically
  if (mode === "add") {
    setValue(
      "state_id",
      telangana.id
    );

    setValue(
      "state_name",
      "Telangana"
    );
  }

  // For EDIT, preserve the existing state_id
  // but make sure the visible name is correct
  if (mode === "edit") {
    setValue(
      "state_name",
      "Telangana"
    );
  }
}, [
  states,
  mode,
  setValue,
]);


  /* =====================================================
     PROFILE AUTO FILL
  ===================================================== */

  useEffect(() => {

    if (
      mode !== "add"
    ) {
      return;
    }


    if (!profileData) {
      return;
    }


    setValue(
      "name",
      profileData.username ||
      ""
    );


    setValue(
      "email",
      profileData.email ||
      ""
    );


    setValue(
      "phone",
      profileData.phone_number ||
      ""
    );

  }, [
    profileData,
    mode,
    setValue,
  ]);


  /* =====================================================
     LOCATION DATA
  ===================================================== */

 useEffect(() => {
  if (mode !== "add" || !locationData) {
    return;
  }

  /*
   * LOCATION
   * Always take latitude and longitude
   * from the selected map location.
   */
  setValue(
    "latitude",
    locationData.latitude != null
      ? String(locationData.latitude)
      : ""
  );

  setValue(
    "longitude",
    locationData.longitude != null
      ? String(locationData.longitude)
      : ""
  );


  /*
   * CITY
   * Automatically fill city from map.
   */
  setValue(
    "city",
    locationData.city || ""
  );


  /*
   * PINCODE
   * Automatically fill pincode from map.
   */
  setValue(
    "zip",
    locationData.zip || ""
  );


  /*
   * STATE
   */
  if (locationData.state) {
    setValue(
      "state_name",
      locationData.state
    );
  }


  /*
   * COUNTRY
   */
  if (locationData.country) {
    setValue(
      "country_name",
      locationData.country
    );
  }


  /*
   * IMPORTANT:
   *
   * Do NOT set:
   *
   * setValue("address", locationData.address)
   *
   * because Full Address must be entered
   * manually by the user.
   */
}, [
  locationData,
  mode,
  setValue,
]);


  /* =====================================================
     EDIT DATA
  ===================================================== */

/* =====================================================
   EDIT DATA
===================================================== */

useEffect(() => {
  if (mode !== "edit" || !initialData) {
    return;
  }

  // State can come as:
  // state_name, state, or state_id object
  const stateName =
    typeof initialData.state_name === "string" &&
    initialData.state_name.trim()
      ? initialData.state_name
      : typeof initialData.state === "string" &&
        initialData.state.trim()
      ? initialData.state
      : "Telangana";

  const stateId =
    typeof initialData.state_id === "object"
      ? initialData.state_id?.id ?? ""
      : initialData.state_id ?? "";

  // Country is fixed in your form
  const countryName = "India";
  const countryValue = countryId;

  reset({
    country_id: countryValue,

    // IMPORTANT:
    // This MUST exactly match:
    // <option value="India">
    country_name: countryName,

    state_id: stateId,

    // IMPORTANT:
    // This MUST exactly match:
    // <option value="Telangana">
    state_name: stateName || "Telangana",

    name:
      initialData.name || "",

    address:
      initialData.address || "",

    city:
      initialData.city || "",

    zip:
      initialData.zip || "",

    phone:
      initialData.phone || "",

    email:
      initialData.email || "",

    latitude:
      initialData.latitude ?? "",

    longitude:
      initialData.longitude ?? "",
  });

  setAddressType(
    initialData.address_type || "Home"
  );

}, [
  mode,
  initialData,
  reset,
  countryId,
]);

  /* =====================================================
     SUBMIT
  ===================================================== */

  const onSubmit = (
    data
  ) => {

    const payload = {

      ...data,

      country_id:
        countryId,

      country_name:
        data.country_name ||
        "India",

      state_name:
        data.state_name ||
        "Telangana",

      latitude:
        data.latitude ||
        "",

      longitude:
        data.longitude ||
        "",

      address_type:
        addressType,
    };


    console.log(
      "FINAL ADDRESS PAYLOAD:",
      payload
    );


    /* =================================================
       UPDATE
    ================================================= */

    if (
      mode === "edit"
    ) {

      updateAddress(
        {
          id:
            addressId,

          payload,
        },

        {

        onSuccess: (response) => {

 

  // Send updated address back to CheckoutPayment
  if (onSave) {
    onSave(response?.data || response);
  }

  onClose();
},

          onError: (
            err
          ) => {

            console.error(
              "UPDATE ADDRESS ERROR:",
              err
            );

            toast.error(
              err?.response?.data?.message ||
              "Could not update the address."
            );
          },

        }
      );

      return;
    }


    /* =================================================
       ADD
    ================================================= */

    addAddress(
      payload,

      {

        onSuccess: () => {

          toast.success(
            "Your address has been added successfully."
          );

          reset();

          onClose();
        },


        onError: (
          err
        ) => {

          console.error(
            "ADD ADDRESS ERROR:",
            err
          );

          toast.error(
            err?.response?.data?.message ||
            "Could not save address."
          );
        },

      }
    );
  };


  /* =====================================================
     DISPLAY ADDRESS
  ===================================================== */

  const displayAddress =
    locationData?.address ||
    initialData?.address ||
    "Your selected delivery location";


  return (
    <div
      className={
        styles.formModal
      }
    >

      {/* =================================================
          HEADER
      ================================================= */}

      <div
        className={
          styles.formHeader
        }
      >

        <HeadingTitle
          text={
            mode === "edit"
              ? "Edit Address"
              : "Add Address Details"
          }

          style={
            styles.addAddressTitle
          }
        />


        <button
          type="button"
          className={
            styles.closeBtn
          }
          onClick={
            onClose
          }
        >
          ×
        </button>

      </div>


      {/* =================================================
          FORM
      ================================================= */}

      <form
        className={
          styles.addressForm
        }
        onSubmit={
          handleSubmit(
            onSubmit
          )
        }
      >

        {/* =================================================
            LOCATION CARD
        ================================================= */}

        <div
          className={
            styles.locationCard
          }
        >

          <div
            className={
              styles.locationIcon
            }
          >
            <FaMapMarkerAlt />
          </div>


          <div
            className={
              styles.locationInfo
            }
          >

            <strong>
              Delivery Location
            </strong>

            <p>
              {displayAddress}
            </p>

          </div>


          {mode === "add" &&
            onEditLocation && (

            <button
              type="button"
              className={
                styles.editLocationBtn
              }
              onClick={
                onEditLocation
              }
            >
              Change
            </button>

          )}

        </div>


        {/* =================================================
            SAVE AS
        ================================================= */}

        <div
          className={
            styles.saveAsSection
          }
        >

          <label
            className={
              styles.sectionLabel
            }
          >
            Save Address as
          </label>


          {/* <div
            className={
              styles.addressTypeList
            }
          >

            <button
              type="button"

              className={
                addressType ===
                "Home"
                  ? `${styles.typeBtn} ${styles.activeType}`
                  : styles.typeBtn
              }

              onClick={() =>
                setAddressType(
                  "Home"
                )
              }
            >

              <FaHome />

              Home

            </button>


            <button
              type="button"

              className={
                addressType ===
                "Work"
                  ? `${styles.typeBtn} ${styles.activeType}`
                  : styles.typeBtn
              }

              onClick={() =>
                setAddressType(
                  "Work"
                )
              }
            >

              <FaBriefcase />

              Work

            </button>


            <button
              type="button"

              className={
                addressType ===
                "Other"
                  ? `${styles.typeBtn} ${styles.activeType}`
                  : styles.typeBtn
              }

              onClick={() =>
                setAddressType(
                  "Other"
                )
              }
            >

              <FaMapMarkerAlt />

              Other

            </button>

          </div> */}

        </div>


        <div
          className={
            styles.divider
          }
        />


        {/* =================================================
            FULL NAME
        ================================================= */}

        <div
          className={`${styles.fieldGroup} ${styles.fullWidth}`}
        >

          <label
            className={
              styles.fieldLabel
            }
          >
            Full Name
          </label>


          <div
            className={
              styles.inputWrapper
            }
          >

       <Input
  placeholder="Enter your full name"
  name="name"
  register={register}
  validation={{
    required: "Name is required",
  }}
  error={errors.name?.message}
/>

          </div>

        </div>


        {/* =================================================
            FULL ADDRESS
        ================================================= */}

        <div
          className={`${styles.fieldGroup} ${styles.fullWidth}`}
        >

          <label
            className={
              styles.fieldLabel
            }
          >
            Full Address
          </label>


          <textarea
            className={
              styles.addressTextarea
            }

            placeholder="House / Flat No, Street, Area, Landmark"

            rows={3}

            {...register(
              "address",
              {
                required:
                  "Full address is required",

                minLength: {
                  value: 10,

                  message:
                    "Please enter a complete address",
                },
              }
            )}
          />


          {errors.address
            ?.message && (

            <span
              className={
                styles.errorMessage
              }
            >
              {
                errors.address
                  .message
              }
            </span>

          )}

        </div>


        {/* =================================================
            CITY + PINCODE
        ================================================= */}

        <div
          className={
            styles.fieldGrid
          }
        >

          <div
            className={
              styles.fieldGroup
            }
          >

            <label
              className={
                styles.fieldLabel
              }
            >
              City
            </label>


            <div
              className={
                styles.inputWrapper
              }
            >

              <Input
                placeholder="Enter city"

                name="city"

                register={
                  register
                }

                validation={{
                  required:
                    "City is required",
                }}

                error={
                  errors.city
                    ?.message
                }
              />

            </div>

          </div>


          <div
            className={
              styles.fieldGroup
            }
          >

            <label
              className={
                styles.fieldLabel
              }
            >
              Pincode
            </label>


            <div
              className={
                styles.inputWrapper
              }
            >

           <Input
  placeholder="Pincode"

  name="zip"

  type="text"

  register={register}

  disabled={true}

  error={
    errors.zip?.message
  }
/>


            </div>

          </div>

        </div>


        {/* =================================================
            STATE + COUNTRY
        ================================================= */}

        <div
          className={
            styles.fieldGrid
          }
        >

          <div
            className={
              styles.fieldGroup
            }
          >

            {/* <label
              className={
                styles.fieldLabel
              }
            >
              State
            </label> */}


  <div className={styles.fieldGroup}>
  <label className={styles.fieldLabel}>
    State
  </label>

  {/* Display State */}
  <input
    type="text"
    className={styles.formSelect}
    value="Telangana"
    readOnly
  />

  {/* Actual values submitted to API */}
  <input
    type="hidden"
    {...register("state_name", {
      required: "State is required",
    })}
  />

  <input
    type="hidden"
    {...register("state_id", {
      required: "State is required",
    })}
  />
</div>

          </div>


       <div className={styles.fieldGroup}>

  <label className={styles.fieldLabel}>
    Country
  </label>

  <input
    type="text"
    className={styles.formSelect}
    value="India"
    readOnly
    {...register("country_name")}
  />

  <input
    type="hidden"
    {...register("country_id")}
  />

</div>

        </div>


        {/* =================================================
            MOBILE + EMAIL
        ================================================= */}

        <div
          className={
            styles.fieldGrid
          }
        >

          <div
            className={
              styles.fieldGroup
            }
          >

            <label
              className={
                styles.fieldLabel
              }
            >
              Mobile Number
            </label>


            <div
              className={
                styles.inputWrapper
              }
            >

              <Input
                placeholder="Enter mobile number"

                name="phone"

                type="tel"

                register={
                  register
                }

                validation={{

                  required:
                    "Mobile number is required",

                  pattern: {
                    value:
                      /^[6-9]\d{9}$/,

                    message:
                      "Enter a valid 10-digit mobile number",
                  },

                  maxLength: {
                    value: 10,

                    message:
                      "Mobile number must be 10 digits",
                  },

                  minLength: {
                    value: 10,

                    message:
                      "Mobile number must be 10 digits",
                  },

                  onChange: (
                    e
                  ) => {

                    const value =
                      e.target.value
                        .replace(
                          /\D/g,
                          ""
                        )
                        .slice(
                          0,
                          10
                        );


                    setValue(
                      "phone",
                      value,
                      {
                        shouldValidate:
                          true,

                        shouldDirty:
                          true,
                      }
                    );

                  },

                }}

                error={
                  errors.phone
                    ?.message
                }
              />

            </div>

          </div>


          <div
            className={
              styles.fieldGroup
            }
          >

            <label
              className={
                styles.fieldLabel
              }
            >
              Email ID
            </label>


            <div
              className={
                styles.inputWrapper
              }
            >

              <Input
                placeholder="Enter email address"

                name="email"

                type="email"

                register={
                  register
                }

                validation={{

                  required:
                    "Email is required",

                  pattern: {
                    value:
                      /^[^\s@]+@[^\s@]+\.[^\s@]+$/,

                    message:
                      "Enter a valid email address",
                  },

                }}

                error={
                  errors.email
                    ?.message
                }
              />

            </div>

          </div>

        </div>


        {/* =================================================
            HIDDEN COORDINATES
        ================================================= */}

        <input
          type="hidden"

          {...register(
            "latitude"
          )}
        />


        <input
          type="hidden"

          {...register(
            "longitude"
          )}
        />


        {/* =================================================
            BUTTONS
        ================================================= */}

        <div
          className={
            styles.formButtons
          }
        >

          <Button
            title={
              mode === "edit"
                ? "Update Address"
                : "Save Address"
            }

            type="submit"

            style={
              styles.saveBtn
            }

            disabled={
              isPending ||
              isProfileLoading
            }
          />


          <Button
            title="Cancel"

            type="button"

            style={
              styles.cancelBtn
            }

            onHandler={
              onClose
            }

            disabled={
              isPending
            }
          />

        </div>

      </form>

    </div>
  );
};

export default AddMyAddress;